module.exports = __webpack_public_path__ + "img/37408-006.21911227.jpg";